/** Shared MUI sx for auth forms and landing hero (dark panels). */
import { BRAND, BRAND_SHADOW, BRAND_SHADOW_HOVER } from '../../theme/tokens';

export const authAccent = BRAND.primaryLight;
export const authAccentHover = '#A5B4FC';

export const authDarkFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1.5,
    bgcolor: 'rgba(255,255,255,0.05)',
    '& fieldset': {
      borderColor: 'rgba(255,255,255,0.2)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255,255,255,0.3)',
    },
    '&.Mui-focused fieldset': {
      borderColor: authAccent,
    },
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255,255,255,0.6)',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: authAccent,
  },
  '& .MuiInputBase-input': {
    color: 'white',
  },
  '& .MuiFormHelperText-root': {
    color: 'rgba(255,255,255,0.45)',
  },
};

export const authPrimaryButtonSx = {
  mt: 3,
  height: 48,
  borderRadius: 1.5,
  textTransform: 'none',
  fontSize: '1rem',
  fontWeight: 600,
  color: '#fff',
  background: BRAND.gradient,
  boxShadow: BRAND_SHADOW,
  '&:hover': {
    background: BRAND.gradientHover,
    boxShadow: BRAND_SHADOW_HOVER,
  },
};

export const authLinkButtonSx = {
  cursor: 'pointer',
  textDecoration: 'none',
  color: authAccent,
  fontWeight: 600,
  '&:hover': {
    textDecoration: 'underline',
    color: authAccentHover,
  },
};

/** Deep slate hero background shared by desktop + mobile landing. */
export const landingHeroBgSx = {
  background: `linear-gradient(135deg, ${BRAND.ink} 0%, ${BRAND.slate800} 50%, ${BRAND.slate700} 100%)`,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `radial-gradient(circle at 20% 50%, rgba(99,102,241,0.18) 0%, transparent 50%),
                 radial-gradient(circle at 80% 20%, rgba(139,92,246,0.12) 0%, transparent 45%)`,
    pointerEvents: 'none',
  },
};

export const landingTitleGradientSx = {
  background: `linear-gradient(135deg, #ffffff 0%, ${authAccent} 100%)`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

export const landingSubtitleSx = {
  color: authAccent,
  opacity: 0.95,
};

export const landingCtaButtonSx = {
  color: 'white',
  px: 4,
  py: 1.5,
  fontSize: '1rem',
  fontWeight: 600,
  borderRadius: 2,
  textTransform: 'none',
  background: BRAND.gradient,
  boxShadow: BRAND_SHADOW,
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    background: BRAND.gradientHover,
    transform: 'translateY(-2px)',
    boxShadow: BRAND_SHADOW_HOVER,
  },
};

export const landingOutlinedButtonSx = {
  borderColor: authAccent,
  color: authAccent,
  px: 4,
  py: 1.5,
  fontSize: '1rem',
  fontWeight: 600,
  borderRadius: 2,
  textTransform: 'none',
  borderWidth: 2,
  '&:hover': {
    borderColor: authAccent,
    bgcolor: 'rgba(129, 140, 248, 0.12)',
    borderWidth: 2,
  },
};

export const landingFeatureCardSx = {
  bgcolor: 'rgba(255,255,255,0.12)',
  backdropFilter: 'blur(12px)',
  border: '1px solid rgba(255,255,255,0.18)',
  borderRadius: 2,
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 3,
    background: BRAND.gradient,
    opacity: 0.85,
  },
};

export const landingFeatureIconSx = {
  color: authAccent,
};

export const landingFeatureBadgeSx = {
  display: 'inline-block',
  bgcolor: 'rgba(129, 140, 248, 0.2)',
  px: 1,
  py: 0.3,
  borderRadius: 1,
  mb: 1,
};
